import { useContext } from 'react';
import { FetchPriceQueriesContext } from 'src/contexts';

export const useFetchPriceQueries = () => useContext(FetchPriceQueriesContext);
